<template>
  <section class="choose-theme-sec">

        <!-- sidebar start -->
        <chat-sidebar></chat-sidebar>
        <!-- sidebar end -->

        <!-- main-content start -->
        <div class="main-content main-chat-content popup-chat">

        	<!-- <chat-box></chat-box> -->

        </div>
        <!-- main-content end -->



  </section>
</template>



<script>
    import { EventBus } from '../main';
    export default {


        methods: {


          isCurrentRoute() {

              let url = this.$route.path;

              if(url==='/inbox'){
                EventBus.$emit('isCurrentRoute',true);
              } else {
                EventBus.$emit('isCurrentRoute',false);
              }
              return;

            }

        },

        mounted() {

         this.isCurrentRoute();
         
        }

    }

</script>
